export default (that) => [
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    headerAlign: 'center',
    align: 'center',
    fixed: 'right',
    width: 100,
    visible: !that.disabled,
    slots: { default: 'opt' },
  },
  {
    title: that.$l('table_label_month') || '月份',
    field: 'month',
    headerAlign: 'center',
    align: 'center',
    width: 80,
    formatter: ({ cellValue }) => '第' + cellValue + '月',
  },
  {
    title: that.$l('table_label_plannedSales') || '预计销量',
    field: 'plannedSales',
    headerAlign: 'center',
    align: 'center',
    minWidth: 100,
    editRender: {
      name: 'ElInputNumber',
      props: {
        precision: 0,
        min: 0,
        controls: false,
        clearable: true,
        size: 'mini',
      },
    },
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_unitPrice') || '客单价',
    field: 'unitPrice',
    headerAlign: 'center',
    align: 'center',
    minWidth: 100,
    editRender: {
      name: 'ElInputNumber',
      props: {
        precision: 2,
        min: 0,
        controls: false,
        clearable: true,
        size: 'mini',
      },
    },
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_salesAmount') || '销售额',
    field: 'salesAmount',
    headerAlign: 'center',
    align: 'center',
    minWidth: 100,
    editRender: {
      name: 'ElInputNumber',
      props: {
        precision: 2,
        min: 0,
        controls: false,
        clearable: true,
        size: 'mini',
      },
    },
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_profitRate') || '利润率',
    field: 'profitRate',
    headerAlign: 'center',
    align: 'center',
    minWidth: 100,
    editRender: {
      name: 'ElInputNumber',
      props: {
        precision: 2,
        min: 0,
        max: 99.99,
        controls: false,
        clearable: true,
        size: 'mini',
      },
    },
    formatter: ({ cellValue }) => cellValue + '%',
  },
  {
    title: that.$l('table_label_profitAmount') || '当月利润额',
    field: 'profitAmount',
    headerAlign: 'center',
    align: 'center',
    minWidth: 100,
    editRender: {
      name: 'ElInputNumber',
      props: {
        precision: 2,
        min: 0,
        controls: false,
        clearable: true,
        size: 'mini',
      },
    },
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_totalProfitAmount') || '累计利润额',
    field: 'totalProfitAmount',
    headerAlign: 'center',
    align: 'center',
    minWidth: 100,
    editRender: {
      name: 'ElInputNumber',
      props: {
        precision: 2,
        min: 0,
        controls: false,
        clearable: true,
        size: 'mini',
      },
    },
    formatter: ({ cellValue }) => that.format(cellValue),
  },
]
